var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52949 12.1414C7.7487 10.7653 7.31578 9.24536 7.23071 7.70975L9.94336 7.38477L10.8985 10.7275L8.52949 12.1414ZM8.52949 12.1414C8.96977 12.9173 9.52064 13.6476 10.1822 14.309C10.8437 14.9705 11.5739 15.5214 12.3498 15.9617M12.3498 15.9617C13.7259 16.7425 15.2458 17.1754 16.7814 17.2605L17.1064 14.5478L13.7637 13.5927L12.3498 15.9617Z",
    stroke: "#D62422",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01682 16.3419C2.35354 14.9465 1.9999 13.4085 1.9999 11.834C1.9999 9.04921 3.10615 6.37849 5.07528 4.40936C7.04441 2.44023 9.71513 1.33398 12.4999 1.33398C15.2847 1.33398 17.9554 2.44023 19.9245 4.40936C21.8937 6.37849 22.9999 9.04921 22.9999 11.834C22.9999 14.6188 21.8937 17.2895 19.9245 19.2586C17.9554 21.2278 15.2847 22.334 12.4999 22.334C10.9254 22.334 9.38736 21.9804 7.99197 21.3171L1.3999 22.934L3.01682 16.3419Z",
    stroke: "#D62422",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon_whatsapp.c4bfd896721e54ed9278ed8c5cae1708.svg";
export { ForwardRef as ReactComponent };